/**
 * @module ol/render/ReplayType
 */

/**
 * @enum {string}
 */
export default {
  CIRCLE: 'Circle',
  DEFAULT: 'Default',
  IMAGE: 'Image',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  TEXT: 'Text'
};

//# sourceMappingURL=ReplayType.js.map


// WEBPACK FOOTER //
// ./~/ol/render/ReplayType.js